module.exports = __webpack_public_path__ + "static/manuscrit_en-e292653a39c5c725d402c5bc84ef8de0.jpg";